import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { formatDistanceToNow } from "date-fns";
import { ChatMessage } from "../ChatComponent";
import chatbotImage from "../../../../assets/images/logo192.png";
import userImage from "../../../../assets/images/logo-icon-64.png";

interface ChatMessageItemProps {
  message: ChatMessage;
  currentUser: any;
  thinkingDots: string;
}

const ChatMessageItem: React.FC<ChatMessageItemProps> = React.memo(
  function ChatMessageItem({
    message,
    currentUser,
    thinkingDots,
  }: ChatMessageItemProps) {
    return (
      <li className="mb-4 flex w-full">
        {message.sender === "user" ? (
          // User message
          <div className="w-full flex justify-end">
            <div className="max-w-3xl w-full flex justify-end">
              <div className="flex flex-col items-end">
                <div className="bg-indigo-600 text-white px-4 py-2 rounded-t-lg rounded-bl-lg shadow w-full">
                  {message.message}
                </div>
                <span className="text-slate-400 text-sm mt-1">
                  {formatDistanceToNow(message.timestamp, { addSuffix: true })}
                </span>
              </div>
              <img
                src={currentUser.photoURL || userImage}
                className="w-10 h-10 rounded-full ml-3"
                alt="User"
              />
            </div>
          </div>
        ) : (
          // Bot or Error message
          <div className="w-full flex justify-start">
            <div className="w-full flex">
              <img
                src={chatbotImage}
                className="w-10 h-10 rounded-full mr-3"
                alt="Chatbot"
              />
              <div className="flex flex-col w-full">
                <div
                  className={`${
                    message.isError
                      ? "bg-red-200 text-red-800"
                      : "bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-white"
                  } px-4 py-2 rounded-t-lg rounded-br-lg shadow w-full`}
                >
                  {message.isThinking ? (
                    <>{thinkingDots}</>
                  ) : (
                    <ReactMarkdown
                      remarkPlugins={[remarkGfm]}
                      rehypePlugins={[rehypeRaw]}
                      components={{
                        code({ className, children }) {
                          const match = /language-(\w+)/.exec(className || "");
                          return match ? (
                            <pre
                              className={`language-${match[1]} p-2 rounded-md bg-gray-800 text-white`}
                            >
                              <code>{children}</code>
                            </pre>
                          ) : (
                            <code className="bg-gray-200 px-1 rounded">
                              {children}
                            </code>
                          );
                        },
                      }}
                    >
                      {message.message}
                    </ReactMarkdown>
                  )}
                </div>
                <span className="text-slate-400 text-sm mt-1">
                  {formatDistanceToNow(message.timestamp, { addSuffix: true })}
                </span>
              </div>
            </div>
          </div>
        )}
      </li>
    );
  },
);

export default ChatMessageItem;
